module.exports = __webpack_public_path__ + "img/icon_sjts.a97628fd.png";